"use client";

import { Hero } from "./hero";
import { ExecutiveSummary } from "./executive-summary";
import { CurrentStatus } from "./current-status";
import { SystemHealth } from "./system-health";
import { UptimeMetrics } from "./uptime-metrics";
import { PerformanceMetrics } from "./performance-metrics";
import { IncidentHistory } from "./incident-history";
import { ScheduledMaintenance } from "./scheduled-maintenance";
import { ServiceLevelAgreements } from "./service-level-agreements";
import { MonitoringInfrastructure } from "./monitoring-infrastructure";
import { ResponseProtocols } from "./response-protocols";
import { GlobalOps } from "./global-ops";
import { SecurityStatus } from "./security-status";
import { PlatformUpdates } from "./platform-updates";
import { CommunicationChannels } from "./communication-channels";
import { StatusApi } from "./status-api";
import { HistoricalPerformance } from "./historical-performance";
import { StatusCta } from "./cta";

export function StatusPage() {
  return (
    <>
      <Hero />
      <div className="bg-aurora-emerald">
        <ExecutiveSummary />
      </div>
      <CurrentStatus />
      <div className="bg-aurora-cyan">
        <SystemHealth />
      </div>
      <UptimeMetrics />
      <div className="bg-aurora-purple">
        <PerformanceMetrics />
      </div>
      <IncidentHistory />
      <div className="bg-aurora-amber">
        <ScheduledMaintenance />
      </div>
      <ServiceLevelAgreements />
      <div className="bg-aurora-emerald">
        <MonitoringInfrastructure />
      </div>
      <ResponseProtocols />
      <div className="bg-aurora-cyan">
        <GlobalOps />
      </div>
      <SecurityStatus />
      <div className="bg-aurora-amber">
        <PlatformUpdates />
      </div>
      <CommunicationChannels />
      <div className="bg-aurora-crimson">
        <StatusApi />
      </div>
      <HistoricalPerformance />
      <StatusCta />
    </>
  );
}
